<template>
  <div class="">
    <reservation-month-manager class="mb-3" @monthRange="monthRange"/>

    <b-tabs content-class="mt-3">
      <b-tab title="تنظیمات" active>
        <config-inputs :reservation="reservation">
          <template #p-1>
            <check-in-out-manager :checkInOut="reservationRule.check_in_check_out"/>
          </template>
        </config-inputs>
      </b-tab>

      <b-tab title="ساعت ها">
        <show-times :reservation="reservation"/>
      </b-tab>

      <b-tab title="ایتم اضافه">
        <extra-option :reservation="reservation"/>
      </b-tab>

    </b-tabs>
  </div>
</template>

<script>
import ShowTimes from "./ShowTimes.vue";
import ConfigInputs from "../generalComponent/ConfigInputs.vue";
import ReservationMonthManager from "../generalComponent/ReservationMonthManager.vue";
import ExtraOption from "../generalComponent/ExtraOption/ExtraOption.vue";
import CheckInOutManager from "../day/CheckInOutManager.vue";

export default {
  name: "ReservationDay",
  components: {CheckInOutManager, ReservationMonthManager, ShowTimes, ConfigInputs, ExtraOption},
  props: {
    reservation: {}
  },
  computed: {
    reservationRule() {
      return this.reservation.reservationRule
    }
  },
  methods: {
    async monthRange(data) {

      const ReservationForm = {
        product: this.reservation.product,
        month: this.$store.getters['Reservation/getMonth'],
        year: this.$store.getters['Reservation/getYear'],
        withoutState: true,
        rules: JSON.stringify(this.reservation.reservationRule)
      }

      this.$store.commit('Reservation/setReservationTimes', [])
      let DashboardProductRules = await this.$store.dispatch("Reservation/getDashboardProductRules", ReservationForm);
      let reservationTimes = DashboardProductRules.data.data.reservation_times
      this.$store.commit('Reservation/setReservationTimes', reservationTimes)

    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>